import {
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { inject, Injector } from '@angular/core';
import { NotificationService } from '../services/notification/notification.service';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@app/app.routes.model';
import { StorageService } from '../services/storage/storage.service';
import { IssueReportService } from '@core/services/issue-report/issue-report.service';

export const SPECIFIC_ERROR_PREFIX = new HttpContextToken<string | null>(
  () => null,
);

// Used for handling errors without notification toaster
export const BYPASS_ERROR_NOTIFICATION = new HttpContextToken<boolean>(
  () => false,
);

export const GENERAL_ERRORS = [
  'invalid-token',
  'expired-token',
  'email-in-used',
];

export const httpErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const storageService = inject(StorageService);
  const issueReportService = inject(IssueReportService);
  const router = inject(Router);
  const appRoutes = APP_ROUTES;
  const errorTranslationPrefix = 'api.errors.';
  const injector = inject(Injector);

  if (request.context.get(BYPASS_ERROR_NOTIFICATION)) {
    return next(request);
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      // Workaround for circular dependency of TranslateService
      issueReportService.captureError(error);
      const notificationService = injector.get(NotificationService);
      const specificErrorPrefix = request.context.get(SPECIFIC_ERROR_PREFIX);
      let byPassErrorNotification = false;
      let errorMessage = errorTranslationPrefix;

      switch (error.status) {
        case 400:
          console.error('ErrorCode(400):', error.error.code);
          switch (error.error.code) {
            case 'Team/admin-count-must-be-at-least-one':
            case 'Organization/admin-count-must-be-at-least-one':
            case 'FileUpload/no-such-file':
            case 'validation/invalid-args':
            case 'registration/email-in-used':
              // skip redirection
              break;
            default:
              router.navigate([appRoutes.generalErrorPage], {
                skipLocationChange: true,
              });
              break;
          }
          break;
        case 401:
          storageService.cleanAuthStorage();
          router.navigate([appRoutes.signIn]);
          break;
        case 403:
          router.navigate([appRoutes.home]);
          break;
        case 404:
          router.navigate([appRoutes.notFound], { skipLocationChange: true });
          byPassErrorNotification = true;
          break;
        default:
          router.navigate([appRoutes.generalErrorPage], {
            skipLocationChange: true,
          });
      }

      const errorCode = error.error?.code;
      if (errorCode) {
        if (GENERAL_ERRORS.includes(errorCode) && specificErrorPrefix) {
          errorMessage += specificErrorPrefix + '.' + errorCode;
        } else {
          errorMessage = error.error.detail;
        }
      } else {
        errorMessage += 'fallback'; // TODO
      }

      console.error('errorCode:', errorCode);
      console.error('specificErrorPrefix:', specificErrorPrefix);
      console.error('errorMessage:', errorMessage);
      console.error('Error:', error);
      console.error('Request:', request);

      if (!byPassErrorNotification) {
        notificationService.showError(errorMessage);
      }

      return throwError(() => new Error(errorMessage));
    }),
  );
};
